(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Marketing.Pipeline",
                {
                    url: "/Pipeline/{pipelineId}",
                    component: "pipeline",
                    resolve: {
                        pipelines: [
                            "pipelineApi", function (pipelineApi) {
                                return pipelineApi.getCurrentUserPipelines();
                            }
                        ],
                        pipeline: [
                            "$q", "pipelineApi", "enrollmentApi", "$transition$", function ($q, pipelineApi, enrollmentApi, $transition$) {
                                return pipelineApi.get($transition$.params().pipelineId).then(function (pipeline) {
                                    var promises = [];

                                    promises.push(pipelineApi.getPipes(pipeline.Id).then(function (pipes) {
                                        pipeline.Pipes = pipes;
                                    }));

                                    promises.push(enrollmentApi.getPipelineEnrollments(pipeline.Id).then(function (enrollments) {
                                        pipeline.Enrollments = enrollments;
                                    }));

                                    return $q.all(promises).then(function() {
                                        return pipeline;
                                    });
                                });
                            }
                        ]
                    }
                });
        }
    ]);

    app.component("pipeline",
        {
            templateUrl: "/App/Marketing/Pipeline/pipeline.html",
            controller: pipelineController,
            bindings: {
                currentUser: "<",
                pipelines: "<",
                pipeline: "<"
            }
        });
    
    function pipelineController(_, $q, $rootScope, $state, $timeout, $mdDialog, orderByFilter, pipelineModalService, pipelineApi, enrollmentApi, clientApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {},
                searchText: {},
                searchClient: {},
                updatePipeline: updatePipeline,
                openAddPipeline: openAddPipeline,
                goToPipeline: goToPipeline,
                addPipe: addPipe,
                updatePipe: updatePipe,
                deletePipeline: deletePipeline,
                deletePipe: deletePipe,
                deleteEnrollment: deleteEnrollment,
                searchClients: searchClients,
                addEnrollment: addEnrollment,
                openAddEnrollment: openAddEnrollment,
                openEditEnrollment: openEditEnrollment,
                pipeMoved: pipeMoved,
                pipeDropped: pipeDropped,
                enrollmentDropped: enrollmentDropped,
                selectedPipelineId: null
            });

        function updatePipeline() {
            if (!!$ctrl.pipeline.Name) {
                pipelineApi.update($ctrl.pipeline).then(function() {
                    $ctrl.ui.editName = false;
                });
            }
        }

        function openAddPipeline($event) {
            pipelineModalService.openAddPipeline($event);
        }

        function goToPipeline() {
            $ctrl.ui.loading = true;
            $timeout(function() {
                    $state.go("Home.Marketing.Pipeline", { pipelineId: $ctrl.selectedPipelineId });
                },
                200);
        }

        function addPipe() {
            $ctrl.ui.saving = true;
            var pipe = {
                Id: 9999,
                Name: $ctrl.newPipeName,
                Order: $ctrl.pipeline.Pipes.length,
                Enrollments: []
            };
            $ctrl.pipeline.Pipes.push(pipe);
            $ctrl.newPipeName = null;

            pipelineApi.addPipe($ctrl.pipeline.Id, pipe).then(function (response) {
                pipe.Id = response.Id;
                $ctrl.ui.saving = false;
            });
        }
        
        function updatePipe(pipe) {
            pipelineApi.updatePipe($ctrl.pipeline.Id, pipe.Id, pipe);
        }

        function deletePipeline($event) {
            pipelineModalService.confirmPipelineDeletion($event).then(() => {
                $ctrl.ui.loading = true;

                pipelineApi.delete($ctrl.pipeline.Id).then(() => {
                    $state.go("Home.Marketing.Pipelines", {}, {});
                });
            });
        }

        function deletePipe($event, pipeId) {
            pipelineModalService.confirmPipeDeletion($event).then(() => {
                _.remove($ctrl.pipeline.Pipes,
                    function(pipe) {
                        return pipe.Id === pipeId;
                    });

                _.remove($ctrl.pipeline.Enrollments,
                    function(enrollment) {
                        return enrollment.PipeId === pipeId;
                    });

                pipelineApi.removePipe($ctrl.pipeline.Id, pipeId);
            });
        }

        function deleteEnrollment($event, enrollmentId) {
            pipelineModalService.confirmEnrollmentDeletion($event).then(() => {
                _.remove($ctrl.pipeline.Enrollments,
                    function(enrollment) {
                        return enrollment.Id === enrollmentId;
                    });

                enrollmentApi.delete(enrollmentId);
            });
        }

        function searchClients(term) {
            return clientApi.searchClients(term).then(function (result) {
                result = _.reject(result,
                    function (row) {
                        return _.find($ctrl.pipeline.Enrollments,
                            function (enrollment) {
                                return enrollment.Client.Id === row.Id;
                            });
                    });

                ng.forEach(result,
                    function (row) {
                        row.Term = row.Person.FirstName + " " + row.Person.LastName;
                    });

                result.push({ Term: "Create " + term, Name: term, Type: "NewClient" });
                return result;
            });
        }

        function addEnrollment(searchClient, pipe, $event) {
            if (!!searchClient) {
                if (searchClient.Type === "NewClient") {
                    var firstSpaceIndex = searchClient.Name.indexOf(" ");
                    var lastSpaceIndex = searchClient.Name.lastIndexOf(" ");
                    var nameLength = searchClient.Name.length;

                    var client = {
                        Person: {
                            FirstName: searchClient.Name.substring(0, firstSpaceIndex !== -1 ? firstSpaceIndex : nameLength),
                            MiddleName: lastSpaceIndex !== firstSpaceIndex ? searchClient.Name.substring(firstSpaceIndex + 1, lastSpaceIndex) : null,
                            LastName: searchClient.Name.substring(lastSpaceIndex !== -1 ? lastSpaceIndex + 1 : nameLength, nameLength)
                        }
                    };

                    $ctrl.searchClient[pipe.Id] = null;
                    openAddEnrollment(pipe, client, $event);
                } else {
                    var enrollment = {
                        PipelineId: $ctrl.pipeline.Id,
                        PipeId: pipe.Id,
                        ClientId: searchClient.Id,
                        Client: searchClient,
                        AssignedUserId: $ctrl.currentUser.Id,
                        AssignedUser: $ctrl.currentUser
                    };
                    pipe.Enrollments.push(enrollment);
                    $ctrl.pipeline.Enrollments.push(enrollment);
                    $ctrl.searchClient[pipe.Id] = null;

                    enrollmentApi.addClientEnrollment($ctrl.pipeline.Id, enrollment).then(function (response) {
                        enrollment.Id = response.Id;
                    });
                }
            }
        }

        function openAddEnrollment(pipe, client, $event) {
            pipelineModalService.openAddEnrollment($ctrl.pipeline, pipe, $ctrl.currentUser, client, $event).then(
                enrollment => {
                    if (!!enrollment.Id) {
                        pipe.Enrollments.push(enrollment);
                        $rootScope.$applyAsync();
                    }
                });
        }

        function openEditEnrollment(pipe, enrollment, $event) {
            pipelineModalService.openEditEnrollment($ctrl.pipeline, pipe, enrollment, $event).then(response => {
                if (response === null) {
                    _.remove(pipe.Enrollments,
                        function(e) {
                            return e.Id === enrollment.Id;
                        });
                } else {
                    if (response.PipeId !== pipe.Id) {
                        _.remove(pipe.Enrollments,
                            function(e) {
                                return e.Id === enrollment.Id;
                            });
                        var newPipe = _.find($ctrl.pipeline.Pipes,
                            function(p) {
                                return p.Id === response.PipeId;
                            });
                        newPipe.Enrollments.push(response);
                    } else {
                        enrollment = response;
                    }
                }
            });
        }

        function pipeMoved(pipe) {
            _.remove($ctrl.pipeline.Pipes,
                function (p) {
                    return pipe.$$hashKey === p.$$hashKey;
                });
        }

        function pipeDropped(event, index, pipe) {
            var promises = [];

            index = index === 0 ? 0 : index - 1;
            var order = $ctrl.pipeline.Pipes[index].Order;

            ng.forEach($ctrl.pipeline.Pipes,
                function (row) {
                    if (pipe.Order > order && row.Order >= order && row.Order < pipe.Order) {
                        row.Order++;
                        promises.push($ctrl.updatePipe(row));
                    } else if (pipe.Order < order && row.Order > pipe.Order && row.Order <= order) {
                        row.Order--;
                        promises.push($ctrl.updatePipe(row));
                    }
                });

            pipe.Order = order;
            promises.push($ctrl.updatePipe(pipe));
            $ctrl.pipeline.Pipes = orderByFilter($ctrl.pipeline.Pipes, "Order");
            $q.all(promises);

            return pipe;
        }

        function enrollmentDropped(enrollment, pipeId) {
            enrollment.PipeId = pipeId;
            enrollmentApi.updateClientEnrollment($ctrl.pipeline.Id, enrollment);
            return enrollment;
        }

        function initPipeEnrollments() {
            ng.forEach($ctrl.pipeline.Pipes,
                function(pipe) {
                    pipe.Enrollments = _.filter($ctrl.pipeline.Enrollments,
                        function(enrollment) {
                            return enrollment.PipeId === pipe.Id;
                        });
                });
        }

        $ctrl.$onInit = () => {
            $ctrl.selectedPipelineId = $ctrl.pipeline.Id;
            $ctrl.pipeline.Pipes = orderByFilter($ctrl.pipeline.Pipes, "Order");
            initPipeEnrollments();
        }
    }

})(window.app, window.angular); //jshint ignore:line